import React, { useEffect } from 'react';
import useUserStore from 'store/user';
import Button from '@material-ui/core/Button';
import { useHistory } from 'react-router-dom';
import { shouldShowOnboardingWelcomeUser } from 'utilities/user-setttings-util';
import { makeStyles } from '@material-ui/core/styles';
import { useMutation } from '@apollo/client';
import UPDATE_USER_SETTING_PLI_ONBOARDING_WELCOME from 'graph/settings/settings-user/update-user-setting-pli-onboarding-welcome';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import GET_ME from 'graph/user/get-me-query';
import { User } from 'types/schema-generated-types';

const useStyles = makeStyles(() => {
  return {
    container: {
      width: '100%',
      height: '100vh',
      margin: 'auto 0',
      position: 'relative',
      zIndex: 1201,
      backgroundColor: 'black'
    },
    imgContainer: {
      width: '100%',
      backgroundImage: 'url("images/pli-welcome-overlay.png")',
      backgroundRepeat: 'no-repeat',
      height: '100%'
    },
    actionsContainer: {
      position: 'absolute',
      bottom: 70,
      right: 30,
      display: 'flex'
    }
  };
});

const getMeSettingsCacheUpdate = (): any => ({
  /* this is not the most performant way, but its a one-time thing, so shouldn't be a problem */
  refetchQueries: [
    {
      query: GET_ME
    }
  ]
});

const WelcomePage: React.FC = () => {
  const { t } = useTranslation('Onboarding');
  const [{ me }] = useUserStore();
  const history = useHistory();
  const classes = useStyles();
  const [updateUserSettingPliOnboardingWelcome] = useMutation(
    UPDATE_USER_SETTING_PLI_ONBOARDING_WELCOME,
    getMeSettingsCacheUpdate()
  );

  const handleClose = (): void => {
    const historyState = history.location?.state as any;

    if (!historyState?.redirect) history.replace('/dashboard');

    history.replace(`${historyState.redirect?.pathname}${historyState.redirect?.search ?? ''}`);
  };

  useEffect(() => {
    if (!shouldShowOnboardingWelcomeUser(me as User)) return;

    updateUserSettingPliOnboardingWelcome({ variables: { data: { value: true } } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.imgContainer}>
        <div className={classes.actionsContainer}>
          <Button
            variant="outlined"
            disableElevation
            onClick={handleClose}
            aria-label={t('Close Tutorial')}
            startIcon={<CloseIcon />}
          >
            <span>{t('Close Tutorial')}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
